// Single source of truth for RAMS severity/consequence categories & colors.
// Matches the severity scale defined in the backend (DEFAULT_SEVERITY_SCALE).
export const SEVERITY_COLORS = {
  Catastrophic: "#dc2626",
  Critical: "#d97706",
  Marginal: "#65a30d",
  Insignificant: "#16a34a",
};

export const SEVERITY_ORDER = ["Catastrophic", "Critical", "Marginal", "Insignificant"];

export function severityColor(label) {
  return SEVERITY_COLORS[label] || "#64748b";
}

// Small colored pill used to render a severity/consequence category consistently
// across every table & menu (Event Explorer, Recent Events, Rollingstock, Kiosk...).
export function SeverityBadge({ value, className = "" }) {
  if (!value) return <span className="text-slate-300">—</span>;
  const color = severityColor(value);
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider whitespace-nowrap ${className}`}
      style={{ color, background: color + "1a", border: `1px solid ${color}40` }}
    >
      {value}
    </span>
  );
}
